import { render } from "./Baberrage.vue?vue&type=template&id=0f3db476&scoped=true"
import script from "./Baberrage.vue?vue&type=script&lang=js"
export * from "./Baberrage.vue?vue&type=script&lang=js"

import "./Baberrage.vue?vue&type=style&index=0&id=0f3db476&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3db476"]])

export default __exports__